module.exports = __webpack_public_path__ + "img/agrobanco.36f1229c.svg";